import styled from 'styled-components'

const BackgroundImageToggleContainer = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 240px;
`

export default BackgroundImageToggleContainer
